/* eslint-disable max-len */
import React, { useContext } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { LuMaximize } from 'react-icons/lu';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { callTimerFormat } from '../../../../../../../../libs/HelperContent';

const AudioCallsHeader = (props) =>
{
	const { onGoingCall, handleMaxScreen, duration } = props;
	const { language } = useContext(LanguageContext);

	return (
		<Box
			alignItems='center'
			display='flex'
			sx={{
				bgcolor      : onGoingCall ? '#90D89F' : 'transparent',
				p            : 1,
				borderRadius : '13px 13px 0 0 '
			}}
		>
			<Stack
				direction='row'
				alignItems='center'
				justifyContent={onGoingCall ? 'space-between' : 'flex-end'}
				width='100%'
			>
				{/* Header text */}
				{onGoingCall && (
					<Typography variant='inherit' fontSize={16} fontWeight={500}>
						{onGoingCall ? callTimerFormat(duration) : language?.audioCall}
					</Typography>
				)}

				{/* Maximize button */}
				{onGoingCall && <LuMaximize fontSize={18} onClick={handleMaxScreen} style={{ cursor: 'pointer' }} />}
			</Stack>
		</Box>
	);
};

export default AudioCallsHeader;
